import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

export default function Contact() {
  const intialState ={name:"",email:"",subject:"",message:"",phone:""}
  const [contacts, setContacts] = useState(intialState);
  const [errors, setErrors] = useState({});

  const handleChange = ({ target }) => {
    let { name, value } = target;
    setContacts({ ...contacts, [name]: value });
  };
  const validate = (values) => {
  const newErrors = {};
  if (!values.name.trim()) {
    newErrors.name = "Name is required";
  }
  if (!values.email) {
    newErrors.email = "Email is required";
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    newErrors.email = "Email is invalid";
  }
  if (!values.subject.trim()) {
    newErrors.subject = "Subject is required";
  }
  if (!values.phone) {
    newErrors.phone = "Phone number is required";
  } else if (!/^[0-9]{10}$/.test(values.phone)) {
    newErrors.phone = "Phone must be 10 digits";
  }
  if (!values.message.trim()) {
    newErrors.message = "Message is required";
  }
  return newErrors;
};

  const handleSubmit = async (e) => {
    e.preventDefault();
const formErrors = validate(contacts);

  if (Object.keys(formErrors).length > 0) {
    setErrors(formErrors);
    return; // stop submit if errors exist
  }
  setErrors({});

    try {
      await axios.post(
        "https://sunrise-backend.sunrisemeditechsystems.com/api/contacts/create",
        contacts
      );
      setContacts(intialState);
      toast.success("Contacts create successfully!", {
        position: "top-right",
        autoClose: 3000, // 3 seconds
      });
    } catch (error) {
      console.error("❌ Error:", error);
    }
  };
  const goHome = () => {
 window.location.href ="https://sunrisemeditechsystems.com";
};
  return (
    <>
      {/* BREADCRUMB AREA START */}
      <div
        className="ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image "
        data-bs-bg="img/bg/sunrise-medical.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__breadcrumb-inner">
                <h1 className="page-title">Contact Us</h1>
                <div className="ltn__breadcrumb-list">
                  <ul>
                    <li>
                      <Link
                        to="#"
                        onClick={goHome}
                        className="bg-black-color"
                        style={{ cursor: "pointer" }}
                      >
                        <span className="ltn__secondary-color">
                          <i className="fas fa-home bg-black-color" />
                        </span>{" "}
                        Home
                      </Link>
                    </li>
                    <li>Contact</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* BREADCRUMB AREA END */}
      {/* CONTACT ADDRESS AREA START */}
      <div className="ltn__contact-address-area mb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img src="img/icons/10.png" alt="Icon Image1" />
                </div>
                <h3>Email Address</h3>
                <p>
                  info@sunrisemeditechsystems.com
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img src="img/icons/11.png" alt="Icon Image2" />
                </div>
                <h3>Phone Number</h3>
                <p>
                  +9879793195
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="ltn__contact-address-item ltn__contact-address-item-3 box-shadow">
                <div className="ltn__contact-address-icon">
                  <img src="img/icons/12.png" alt="Icon Image3" />
                </div>
                <h3>Office Address</h3>
                <p>
                 Sardar Patel Ringroad, Zundal, Ahmedabad
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* CONTACT ADDRESS AREA END */}
      {/* CONTACT MESSAGE AREA START */}
      <div className="ltn__contact-message-area mb-120 mb--100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__form-box contact-form-box box-shadow white-bg">
                <h4 className="title-2">Get A Quote</h4>
                <form id="contact-form" action="mail.php" method="post">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="input-item input-item-name ltn__custom-icon ">
                        <input
                          type="text"
                          name="name"                         
                          placeholder="Enter your name"
                          value={contacts.name}
                          onChange={handleChange}
                         className="contact-input"
                        />
                      </div>
                        {errors.name && <small className="text-danger">{errors.name}</small>}
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="input-item input-item-email ltn__custom-icon">
                        <input
                          type="email"
                          name="email"
                          placeholder="Enter email address"
                          value={contacts.email}
                          onChange={handleChange}
                         className="contact-input"
                        />
                      </div>
                         {errors.email && <small className="text-danger">{errors.email}</small>}
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="input-item input-item-subject ltn__custom-icon">
                        <input
                          type="text"
                          name="subject"
                          placeholder="Enter the subject"
                          value={contacts.subject}
                          onChange={handleChange}
                          className="contact-input"
                        />
                      </div>
                          {errors.subject && <small className="text-danger">{errors.subject}</small>}
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="input-item input-item-phone ltn__custom-icon">
                        <input
                          type="text"
                          name="phone"
                          placeholder="Enter phone number"
                          maxLength="10"
                          value={contacts.phone}
                          onChange={handleChange}
                         className="contact-input"
                        />
                      </div>
                          {errors.phone && <small className="text-danger">{errors.phone}</small>}
                    </div>
                  </div>
                    {/* <div className="col-md-12 mb-3"> */}
                  <div className="input-item input-item-textarea ltn__custom-icon mb-3">
                    <textarea
                      name="message"
                      placeholder="Enter message"
                      defaultValue={""}
                      value={contacts.message}
                      onChange={handleChange}
                    className="contact-text-input"
                    /><br/>
                  {/* </div> */}
                     {errors.message && <small className="text-danger">{errors.message}</small>}
                  </div>
                  {/* <p>
                    <label className="input-info-save mb-0">
                      <input type="checkbox" name="agree" /> Save my name,
                      email, and website in this browser for the next time I
                      comment.
                    </label>
                  </p> */}
                  <div className="btn-wrapper mt-0">
                    <button
                      className="btn theme-btn-1 btn-effect-1 text-uppercase"
                      type="button"
                      onClick={(e) => handleSubmit(e)}
                    >
                      get a free service
                    </button>
                  </div>
                  <p className="form-messege mb-0 mt-20" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* CONTACT MESSAGE AREA END */}
      {/* GOOGLE MAP AREA START */}
      <div className="google-map mb-120">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9334.271551495209!2d-73.97198251485975!3d40.668170674982946!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25b0456b5a2e7%3A0x68bdf865dda0b669!2sBrooklyn%20Botanic%20Garden%20Shop!5e0!3m2!1sen!2sbd!4v1590597267201!5m2!1sen!2sbd"
          width="100%"
          height="100%"
          frameBorder={0}
          allowFullScreen=""
          aria-hidden="false"
          tabIndex={0}
          title="Google Maps Location"
        />
      </div>
      {/* GOOGLE MAP AREA END */}
    </>
  );
}
